import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useToast } from 'vue-toastification/composition';

export default function useUserManagementList() {

    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    const styleColumns = {
        thClass: 'text-center',
        tdClass: 'text-center'
    }

    // Table Handlers
    let tableColumns = [
        { key: 'fullName', sortable: true, label: 'USUARIO', thClass: styleColumns.thClass },
        { key: 'email', sortable: true, label: 'CORREO', ...styleColumns },
        { key: 'role_name', sortable: true, label: 'ROL', ...styleColumns },
        { key: 'department_name', sortable: true, label: 'DEPARTAMENTO', ...styleColumns },
        { key: 'position_name', sortable: true, label: 'CARGO', ...styleColumns },
        { key: 'status', sortable: true, label: 'ESTADO', ...styleColumns },
        { key: 'actions', sortable: false, label: 'OPCIONES', ...styleColumns }
    ];

    const perPage = ref(10);
    const totalUsers = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('createdAt');
    const isSortDirDesc = ref(true);

    const rolesFilter = ref(null);
    const departmentsFilter = ref(null);
    const statusFilter = ref(null);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalUsers.value,
        }
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery, rolesFilter, departmentsFilter, statusFilter], () => {
        refetchData();
    });

    const fetchUsers = (ctx, callback) => {
        store
            .dispatch('app-user-management/fetchUsers', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,

                roles: rolesFilter.value,
                departments: departmentsFilter.value,
                status: statusFilter.value,
            })
            .then(response => {
                const { users, total } = response.data;
                callback(users);
                totalUsers.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de usuarios',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            })
    };

    return {
        fetchUsers,
        tableColumns,
        perPage,
        currentPage,
        totalUsers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,

        refetchData,

        // Extra Filters
        rolesFilter,
        departmentsFilter,
        statusFilter
    }
}
